// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const Receipt2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "Receipt2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.25 3.058c0-.008 0-.016-.017-.025a.876.876 0 0 0-.708-.358c-.442 0-.975.292-1.55.908-.683.734-1.733.675-2.333-.125L10.8 2.342c-.333-.45-.775-.675-1.217-.675-.441 0-.883.225-1.216.675l-.85 1.125c-.592.791-1.634.85-2.317.125l-.008-.009c-.942-1.008-1.784-1.158-2.259-.55-.016.009-.016.017-.016.025C2.617 3.7 2.5 4.6 2.5 5.867v8.266c0 1.267.117 2.167.417 2.809 0 .008.008.025.016.033.484.6 1.317.45 2.259-.558l.008-.009c.683-.725 1.725-.666 2.317.125l.85 1.125c.333.45.775.675 1.216.675.442 0 .884-.225 1.217-.675l.842-1.116c.6-.8 1.65-.859 2.333-.125.575.616 1.108.908 1.55.908a.868.868 0 0 0 .708-.35.063.063 0 0 0 .017-.033c.3-.642.417-1.542.417-2.809V5.867c0-1.267-.117-2.167-.417-2.809Zm-4.583 9.025h-5a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h5a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Zm1.666-2.916H6.667a.63.63 0 0 1-.625-.625.63.63 0 0 1 .625-.625h6.666a.63.63 0 0 1 .625.625.63.63 0 0 1-.625.625Z"
}));
export default Receipt2Icon;